import { round, padNumberLeft, isNumeric } from "../../helpers/number";

var updateValue = function updateValue(props) {
  var number = props.children;

  if (!isNumeric(number)) {
    return props.children;
  }

  if (props.roundOff) {
    number = round(number, props.precision);
  }

  if (props.padLeft) {
    number = padNumberLeft(number);
  }

  return number;
};

var Value = function Value(_ref) {
  var _ref$roundOff = _ref.roundOff,
      roundOff = _ref$roundOff === void 0 ? false : _ref$roundOff,
      _ref$padLeft = _ref.padLeft,
      padLeft = _ref$padLeft === void 0 ? false : _ref$padLeft,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? 2 : _ref$precision,
      children = _ref.children;
  var updatedValue = updateValue({
    roundOff: roundOff,
    precision: precision,
    children: children,
    padLeft: padLeft
  });
  return updatedValue !== null && updatedValue !== void 0 ? updatedValue : null;
};

Value.displayName = 'Value';
export { Value };
export default Value;